<template>
    <div class="modules">
        <div class="payment-container">
            <div class="summary">
                <h1 class="title"> {{ $t("lang.announcement") }}</h1>
                <!-- <div class="tools">
                    <el-button size="small" @click="submit">{{ $t("lang.feedback") }} <i class="el-icon-right"></i></el-button>
                </div> -->
            </div>
            <div class="box-wrapper">
                <div class="box-main">
                    <div class="step-container">
                        <div class="hd">
                            <div class="list" >
                                <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                                     <van-list  v-model="loading" :finished="finished" finished-text="没有更多了"  @load="onLoad" >
                                        <div v-for="(item, index) in noticeLists" :key="index" >
                                            <el-collapse  accordion  @change="handleChange(item,index)">
                                                <div >
                                                    <el-collapse-item >
                                                        <template slot="title">
                                                            <div class="navRead" v-if="item.readStatus ==0">{{ $t("lang.Unread") }}</div>
                                                            <div class="nav" v-else>{{ $t("lang.Read") }}</div>
                                                            <div class="title">{{ item.titile }}</div>
                                                        </template>
                                                        <div v-html="item.msgContent"></div>
                                                    </el-collapse-item>
                                                </div>
                                            </el-collapse>
                                        </div>
                                    </van-list>
                               </van-pull-refresh>
                            </div>
                           
                        </div>
                    </div>
                </div>
               
            </div>
        </div>
        <van-popup v-model="popupModel" round :close-on-click-overlay="false"  closeable :style="{ height: '50%',width:'25%' }">
            <div class="popup-mod">
                <div class="hd">
                    <h3 class="title"> {{ $t("lang.feedback") }}</h3>
                </div>
                <van-divider />
                <div class="bd">
                      <div class="field">
                        <van-field v-model="message" rows="5" autosize :label="$t('lang.feedback')"  type="textarea" maxlength="100" placeholder="请输入问题反馈" show-word-limit/>
                      </div>
                      <van-divider />
                      <!-- <div class="uploader">
                        <van-uploader :after-read="afterRead" />
                      </div> -->
                </div>
                <div class="ft">
                    <div class="form-action">
                        <van-button    size="large"  type="primary" >{{ $t("lang.submit") }}</van-button>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
    </template>
    <script>
    import {BASE_GLOB_API, BASE_GLOB_DOMAIN} from "@/config.js";
    import {axiosGet, axiosPost} from '@/api/api';
    import { Toast } from 'vant';
    
    export default {
        name:'userFeedback',
        components:{},
        data(){
            return {
                form:{},
                domain:BASE_GLOB_API,
                url:{
                    notice:BASE_GLOB_API+'/notice/page',
                    detail:BASE_GLOB_API+'/notice/detail',
                },
                list: [],
                loading: false,
                finished: false,
                refreshing: false,
                popupModel:false,
                message:'',
                noticeLists:[]
             

               
            }
        },
        created(){
            this.lang = sessionStorage.getItem("Language")
            this.noticeList(1,10)
          
        },
        methods:{
            handleChange(detail,index){
                // console.log("index",index)
                this.noticeLists.splice(index, 1, Object.assign({}, detail, { 'readStatus':1 }))
                // console.log("this.noticeLists",this.noticeLists)
                let params = ''
                axiosGet(this.url.detail+'/'+detail.id,params).then(res=>{
                    if(res.code ==200){
                       
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            noticeList(pageNo,pageSize){
                let params = {
                    pageNo:pageNo,
                    pageSize:pageSize
                }
                axiosPost(this.url.notice,params).then(res=>{
                    if(res.code ==200){
                    this.noticeLists =res.result.records
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            submit(){
                this.popupModel=true;
            },
            onRefresh() {
                // 清空列表数据
                this.finished = false;

                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.onLoad();
            },
            onLoad() {
                setTimeout(() => {
                    if (this.refreshing) {
                        this.list = [];
                        this.refreshing = false;
                    }

                    for (let i = 0; i < 30; i++) {
                        this.list.push(this.list.length + 1);
                    }
                    this.loading = false;

                    if (this.list.length >= 40) {
                        this.finished = true;
                    }
                }, 1000);
            },
        }
    }
    </script>
    <style lang="less" scoped>
    .payment-container {
        .summary {
            background:#f4f5f6; border-radius:4px; padding:30px; display:flex; justify-content: space-between; align-items: center; margin-bottom:30px;
        }
        .box-wrapper {
            display:flex; justify-content: space-between; align-items: flex-start;
            .box-main {
                flex:1;
                .step-container {
                     .hd{
                        .list{
                            height: 40px;
                            line-height: 40px;
                            background-color: #fafafa;
                            text-align: center;
                            .nav{
                               padding:0 30px;
                               color: green;
                            }
                            .navRead{
                               padding:0 30px;
                               color: red;
                            }
                            .title{
                                font-size: 16px;
                                color:black;
                            }
                        }
                        /deep/.van-list__finished-text {
                                padding: 100px 0 0 0;
                            }
                        /deep/.van-list__loading{
                            padding: 100px 0 0 0;
                        }
                     }
                    
                  
                }
            }
           
           
        }
    }
    .popup-mod{
        .hd{
            font-size: 14px;
            line-height: 30px;
            text-align: center;
        }
        .bd{
            .uploader{
                padding: 10px 0 35px 15px;
            }
        }
    }
   
    
    </style>